// extracted by mini-css-extract-plugin
export default {"infoContacts":"InfoContact_infoContacts__3f5tn","list":"InfoContact_list__C6HuP"};